import template from './checkbox-field.html';

const CheckboxFieldComponent = {
    bindings: {
        hideLabel: '<',
        inputClass: '<',
        isChecked: '=',
        label: '<',
        labelClass: '<'
    },
    template
};

export default CheckboxFieldComponent;



// WEBPACK FOOTER //
// ./app/common/form-fields/checkbox-field/checkbox-field-component.js